import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside";
@Component({
  selector: 'app-product-infomation',
  templateUrl: './product-infomation.component.html',
  styleUrls: ['./product-infomation.component.css']
})
export class ProductInfomationComponent implements OnInit {
  @Output() Save = new EventEmitter();
  @Output() Close = new EventEmitter();
  @Input() Item: WebsideDomain.IProduct = undefined;

  constructor() { }
  OnClose() {
    if (this.Close) {
      this.Close.emit();
    }
  }
  ngOnInit() {

  }


  // OnEdit() {
  //   this.typeslists = this.httpService.typeslists;
  //   if (this.product.isEditing === undefined) { this.product.isEditing = true; }
  //   this.product.isEditing = true;
  //   this.productTemp.uuid = this.product.uuid;
  //   this.productTemp.serialno = this.product.serialno;
  //   this.productTemp.type = this.product.type;
  //   this.productTemp.description = this.product.description;
  // }

  // async OnCancel() {
  //   if (this.product.isEditing === undefined) { this.product.isEditing = false; }
  //   this.product.isEditing = false;
  //   this.product.uuid = this.productTemp.uuid;
  //   this.product.serialno = this.productTemp.serialno;
  //   this.product.type = this.productTemp.type;
  //   this.product.description = this.productTemp.description;
  // }
  // async OnSave() {
  //   if (this.product.isEditing === undefined) { this.product.isEditing = false; }
  //   this.requestMessage = "";
  //   if (this.product.type == 0) {
  //     this.requestMessage = "尚未設定產品類型";
  //     return;
  //   }
  //   if (this.Save) {
  //     this.Save.emit([this.product, this.crateMode]);
  //   }
  //   if (this.crateMode) {
  //     this.product = {
  //       uuid: await this.httpService.Get_Product_UUID(),
  //       serialno: "",
  //       type: 0,
  //       description: "",
  //       isEditing: false,
  //     };
  //   }
  //   this.product.isEditing = false;
  // }
  // async onDelete() {
  //   if (!this.crateMode) {
  //     if (this.Delete) {
  //       this.Delete.emit(this.product);
  //     }
  //   }
  // }

  // ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {

  //   if (changes['crateMode'] && this.crateMode) {
  //     if (this.crateMode) {
  //       this.typeslists = this.httpService.typeslists;
  //       this.httpService.Get_Product_UUID().then((uuid) => {
  //         this.product.uuid = uuid;
  //       });
  //     }
  //   }
  // }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product-infomation/product-infomation.component.ts